// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__FsCPd","logo":"MainNavigation_logo__7oxkl"};